/**
 * Where a destination finds its picture. A page canvas. Tag-name checks avoid
 * `instanceof` realm mismatches between the browser, tests, and iframes.
 */

export function isHtmlCanvas(value: unknown): value is HTMLCanvasElement {
  if (typeof value !== "object" || value === null) return false;
  const node = value as { nodeName?: string; getContext?: unknown };
  return node.nodeName === "CANVAS" && typeof node.getContext === "function";
}

export function resolvePictureCanvas(
  element: Element | null | undefined,
): HTMLCanvasElement | null {
  return isHtmlCanvas(element) ? element : null;
}
